'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useLanguage } from '@/lib/contexts/LanguageContext';

import type { ReactNode } from 'react';

export function LanguageSelector(): ReactNode {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm">{t.language}:</span>
      <Select value={language} onValueChange={(value) => setLanguage(value as 'en' | 'sv')}>
        <SelectTrigger className="h-8 w-[120px]">
          <SelectValue placeholder={t.language} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">{t.english}</SelectItem>
          <SelectItem value="sv">{t.swedish}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
